<template>
  <div class="agency-event-ranking-group-entry">
    <div class="ranking-cell">
      <div class="main-component">
        <div class="rank-wrap">
          <div class="rank">
            <p v-if="isRanker" :style="rankStyle" class="rank__ranker">
              {{ rankingItem.rank }}
            </p>
            <p v-else class="rank__normal">
              {{ rankingItem.rank }}<span>{{ suffix }}</span>
            </p>
          </div>
        </div>

        <div class="group-info" @click="openGroupIndividualRanking">
          <div class="group-info__content">
            <p class="group-info__name">{{ rankingItem.groupName }}</p>
            <p class="group-info__score">
              <span>{{ formattedScore }}</span>
            </p>
          </div>
        </div>

        <div class="disclosure-indicator">
          <img src="/img/disclosure-indicator.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatter from '@/utils/Formatter'
import { getRankOrdinalSuffix } from '@/i18n'

const badgeImages = {
  1: '/img/badgeBgFirst.png',
  2: '/img/badgeBgSecond.png',
  3: '/img/badgeBgThird.png',
}

export default {
  name: 'AgencyEventRankingGroupEntry',
  props: {
    rankingItem: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isRanker() {
      return this.rankingItem.rank <= 3
    },
    rankStyle() {
      const bgImage = badgeImages[this.rankingItem.rank]
      if (bgImage) {
        return {
          'background-image': `url(${bgImage})`,
        }
      }
      return null
    },
    suffix() {
      return getRankOrdinalSuffix(this.rankingItem.rank)
    },
    formattedScore() {
      return formatter.numberWithCommas(this.rankingItem.score)
    },
  },
  methods: {
    openGroupIndividualRanking() {
      this.$emit('openGroupIndividualRanking', {
        groupId: this.rankingItem.groupId,
        groupName: this.rankingItem.groupName,
      })
    },
  },
}
</script>

<style scoped>
.agency-event-ranking-group-entry {
  border-bottom: 1px solid #eeeeee;
  color: #262626;
}

.ranking-cell {
  background-color: #ffffff;
}

.main-component {
  display: flex;
  height: 76px;
  max-width: 500px;
  margin: 0 auto;
}

.rank-wrap {
  display: inline-block;
  width: 58px;
  min-width: 58px;
  height: 24px;
  margin: 26px 4px 26px 16px;
}

.rank {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 24px;
}

.rank__ranker {
  background-size: contain;
  color: #ffffff;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
}

.rank__normal {
  vertical-align: middle;
  line-height: 16px;
  font-weight: 600;
  margin: 0;
}

.rank__normal span {
  font-size: 12px;
}

.group-info {
  display: inline-block;
  margin: 0 22px 0 16px;
  min-width: 217px;
  flex: 1;
  cursor: pointer;
}

.group-info__content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  height: 76px;
}

.group-info__content p {
  flex-basis: 100%;
  margin: 0;
}

.group-info__name {
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.group-info__score {
  font-weight: 600;
  font-size: 12px;
  vertical-align: middle;
  line-height: 150%;
}

.group-info__score span {
  color: #188dff;
}

.disclosure-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 76px;
  margin-right: 16px;
}

.disclosure-indicator img {
  width: 8px;
  height: 13px;
  opacity: 0.6;
}
</style>
